function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.05
}, /*#__PURE__*/React.createElement("path", {
  d: "M443.111 609.106H594.271C605.409 609.106 611.93 596.881 605.482 588.024L184.68 5.70968C182.116 2.12283 177.939 0 173.47 0H22.3096C11.1722 0 4.651 12.2246 11.0989 21.0819L431.9 603.396C434.392 606.983 438.641 609.106 443.111 609.106Z",
  fill: "#0056D2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M178.144 611H11.5232C2.2176 611 -3.27781 600.459 2.14432 592.846L212.215 298.651C214.926 294.845 219.396 292.502 224.085 292.502H383.452C395.176 292.502 402.063 305.532 395.322 315.048L187.449 606.169C185.325 609.243 181.881 611 178.144 611Z",
  fill: "#00E7C5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M404.111 175.472C445.954 175.472 479.874 141.584 479.874 99.7819C479.874 57.9796 445.954 24.092 404.111 24.092C362.268 24.092 328.348 57.9796 328.348 99.7819C328.348 141.584 362.268 175.472 404.111 175.472Z",
  fill: "#00E7C5"
}));

function SvgBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 609,
    height: 611,
    viewBox: "0 0 609 611",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.ca8d2af6.svg";
export { ForwardRef as ReactComponent };